var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.serverSetting && _vm.serverSetting.是否展示 ? _c('div', {
    attrs: {
      "id": "Email"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.serverSetting.邮箱文案) + "\n")]) : _vm.isMounted && _vm.setting && _vm.setting.是否展示 ? _c('div', {
    attrs: {
      "id": "Email"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.setting.邮箱文案) + "\n")]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };